import { validateUrlProtocol } from './validateURL';

// Shared validation rules for a single WhatsApp carousel card. The card editor gates its own Save
// button with these, the card list renders the matching row-level errors, and the message form's
// Save gate runs them again over every card - keeping them in one module is what stops the three
// from drifting apart.

// Meta needs a real, fetchable image at template creation, so a card image must be a literal URL.
export const isValidCardImageUrl = (imageUrl) => !!imageUrl && validateUrlProtocol(imageUrl);

// The destination, on the other hand, follows the same rule as the parent form's Button URL: a
// merge tag (coupon link, tracking URL, ...) is a legitimate value that only resolves at send time.
// Anchored, unlike Regex.mergeTagsRegex: only a value that is *entirely* one tag skips the
// protocol check. A URL that merely embeds a tag (`https://shop.test/{{sku}}`) already passes
// validateUrlProtocol on its own, so an unanchored test would only ever let protocol-less junk
// like `shop.test/{{sku}}` through.
const WHOLE_MERGE_TAG_REGEX = /^\s*{{\s*\w.*?\s*}}\s*$/;
export const isValidCardBtnUrl = (btnUrl) =>
  !!btnUrl && (WHOLE_MERGE_TAG_REGEX.test(btnUrl) || validateUrlProtocol(btnUrl));

export const isValidCard = (card) => isValidCardImageUrl(card?.imageUrl) && isValidCardBtnUrl(card?.btnUrl);
